import { createContext, useContext, useState } from "react";

const GatekeeperContext = createContext();

export const useGatekeeper = () => {
  const context = useContext(GatekeeperContext);
  if (!context) {
    throw new Error("useGatekeeper must be used within a GatekeeperProvider");
  }
  return context;
};

export const GatekeeperProvider = ({ children }) => {
  // Site is now public - no password wall
  // Investor auth will be handled server-side (Item 2)
  const [investorUnlocked, setInvestorUnlocked] = useState(false);

  const unlockInvestor = () => {
    // Placeholder - will be replaced with server-side auth in Item 2
    setInvestorUnlocked(true);
  };

  const lockInvestor = () => {
    setInvestorUnlocked(false);
  };

  return (
    <GatekeeperContext.Provider value={{ 
      investorUnlocked,
      unlockInvestor,
      lockInvestor
    }}>
      {children}
    </GatekeeperContext.Provider>
  );
};

export default GatekeeperProvider;
